import { useRegistrationContext } from '../components/RegistrationProvider';
import { RegistrationUSTaxStatus } from '../components/RegistrationUSTaxStatus/RegistrationUSTaxStatus';
import { useRegistrationUSTaxStatus } from '../hooks';
import { RegistrationStepProps } from '../types';

export const RegistrationUSTaxStatusStep = ({
  canGoBack,
  onGoBack,
  onGoNext,
  onRejected,
}: RegistrationStepProps) => {
  const { onSubmit } = useRegistrationUSTaxStatus({
    onGoNext,
    onRejected,
  });

  const { registrationType } = useRegistrationContext();

  return (
    <RegistrationUSTaxStatus
      canGoBack={canGoBack}
      registrationType={registrationType}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    />
  );
};
